// extracted by mini-css-extract-plugin
module.exports = {"offers-list":"offers-list_offers-list__xH8sQ"};